import React from 'react';
import { Card } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';

const WorkspaceCardItemRequestedStatus = ({ workspace }) => {
  const messageId = workspace.requested_before
    ? 'workspace.dataset.requested.before'
    : 'workspace.dataset.not.requested.before';

  return (
    <Card.Content extra>
      <FormattedMessage id={`${messageId}.${workspace.requested ? 'requested' : 'active'}`} />
    </Card.Content>
  );
};

export default WorkspaceCardItemRequestedStatus;
